import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import Error from '../Shared/Error.js'
import ItemDetailsPane from './ItemDetailsPane.js'
import AddItemPopup from './AddItemPopup.js'
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage.js'

const Certificates = () => {

    const [isLoadingStructure, setIsLoadingStructure] = useState(true);
    const [errorLoadingStructure, setErrorLoadingStructure] = useState(false);
    const [dataTableStructure, setDataTableStructure] = useState({});


    
    // Receives the ExpiryDate (config.rowStyleProcessorColumn)
    const rowStyleProcessor = (value) => {

        if (!value) return "";

        const date = new Date(value);
        const today = new Date();

        // Remove time component for date-only comparison
        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);

        if (date < today) {
            return "datatable-row-red";
        }

        const daysUntilDue = Math.ceil(
            (date - today) / (1000 * 60 * 60 * 24)
        );

        if (daysUntilDue <= 30) {
            return "datatable-row-yellow";
        }

        return "";
    };


    let config = {};

    config.dataUrl = "/umbraco/api/RIMSRegistrations/Certificates";
    config.getSingleItemUrl = "/umbraco/api/RIMSRegistrations/Certificate";
    config.pageTitle = "Certificates";
    config.singleItemTitle = "Certificate";
    config.entityType = "countryregistration-certificate";
    config.entityTypeId = 7;
    config.pageIcon = "fas fa-clipboard";
    config.breadcrumbs = [{ "Name": "Country Registrations", "Link": "/your-medboard/country-registrations/" }, { "Name": "Certificates", "Link": "/your-medboard/country-registrations/certificates/" }]
    config.dataStructure = [];
    //config.exportUrl = "/umbraco/api/RIMSRegistrations/ProductsExport/?productIds=";
    config.deleteUrl = "/umbraco/api/RIMSRegistrations/BulkCertificates/?certificateIds=";
    //config.enableTags = true;
    config.currentLegalManufacturerFilter = window.legalManufacturerId;
    config.currentLegalManufacturerNameFilter = window.legalManufacturerName;
    //config.showExportButton = true;
    config.showDeleteButton = true;
    config.preLoadItemUrlParamName = "certificateId";
    config.defaultOrderByField = "Reference";
    config.complianceStandardsUrl = "/umbraco/api/RIMSRegistrations/Standards/?id=";
    config.complianceRegdocsUrl = "/umbraco/api/RIMSRegistrations/RegulatoryDocuments/?id=";
    config.preLoadItemId = window.preloadCertificateId;
    config.showListTotalCount = true;
    config.listTotalCountURL = "/umbraco/api/RIMSRegistrations/CertificatesCount/";
    config.rowStyleProcessor = rowStyleProcessor;
    config.rowStyleProcessorColumn = "ExpiryDate";
    config.showTaskCount = true;


    useEffect(() => {

        loadStructure();

    }, []);


    const loadStructure = () => {

        setIsLoadingStructure(true);
        setErrorLoadingStructure(false);

        let tableHeaderUrl = "/umbraco/api/CustomFields/Headers/?entityType=" + config.entityTypeId;

        let requestOptions = {
            method: 'GET',
        };

        fetch(tableHeaderUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    setHasMoreData(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                result.map(column => {
                    config.dataStructure.push({
                        customFieldId: column.CustomFieldId,
                        customFieldType: column.CustomFieldType,
                        name: column.Name,
                        field: column.Field,
                        width: column.Width,
                        sortable: column.Sortable,
                        isSelectItemCheckbox: column.IsSelectItemCheckbox,
                        renderWith: FieldTypes[column.RenderWith] ?? FieldTypes.FieldType_Text,
                        isMultiField: column.IsMultiField,
                        disableRowClick: column.DisableRowClick,
                    });
                });

                setDataTableStructure(config);
                setIsLoadingStructure(false);
            })
            .catch((error) => {
                setErrorLoadingStructure(true);
            })
            .finally(() => {
            });
    }

    
    return (<>

        {errorLoadingStructure ? <>
            <Error message={"Failed to load table configuration"} />
        </> : <>
                {isLoadingStructure ? <>
                    <LoadingSpinnerImage />
                </> : <>
                        <DataTable dataTableStructure={dataTableStructure}
                            ItemDetailsPane={ItemDetailsPane}
                            AddItemPopup={AddItemPopup}
                            ReloadStructureFunction={loadStructure} />
                </>}

        </>}


    </>);

};






export default Certificates;